import React from 'react'
import PropTypes from 'prop-types'
import Chip from '../ui/Chip'

const HEADER_CLASS = 'tw:-mx-3.75 tw:-mt-3.75 tw:mb-6 tw:flex tw:flex-wrap tw:items-center tw:gap-2 '
  + 'tw:border-b tw:border-solid tw:border-gray-200 tw:px-3.75 tw:py-5'
const BACK_CLASS = 'tw:flex tw:size-4 tw:shrink-0 tw:items-center tw:justify-center '
  + 'tw:text-xs tw:text-gray-900!'
const HINT_CLASS = 'tw:mb-6 tw:flex tw:flex-wrap tw:items-center tw:justify-between tw:gap-2 '
  + 'tw:text-sm tw:text-gray-600'

const AnswerFormHeader = ({ backUrl, chips }) => (
  <>
    <div className={HEADER_CLASS}>
      <a aria-label="Retour" className={BACK_CLASS} href={backUrl}>
        <i className="fas fa-arrow-left" />
      </a>
      <h2 className="tw:m-0! tw:text-sm! tw:font-medium! tw:text-gray-900!">
        {'Édition d\'une réponse'}
      </h2>
      {chips.map(chip => <Chip key={chip}>{chip}</Chip>)}
    </div>
    <div className={HINT_CLASS}>
      <span className="tw:flex tw:flex-wrap tw:items-center tw:gap-1">
        Astuce : Activez le mode recherche avec
        <Chip>⌘F</Chip>
        sur Mac,
        <Chip>Ctrl F</Chip>
        sur Windows
      </span>
      <span className="tw:text-gray-950">
        <span className="tw:text-ds-warning">*</span>
        {' champs obligatoires'}
      </span>
    </div>
  </>
)

AnswerFormHeader.propTypes = {
  backUrl: PropTypes.string.isRequired,
  chips: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default AnswerFormHeader
